import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable()
export class ToolConfigService {
  private apiBaseUrl = environment.apiBaseUrl;

  constructor(private http: HttpClient) {}

  uploadToolConfig(toolConfig) {
    return this.http
      .post(this.apiBaseUrl + 'api/private/v1/toolConfiguration', toolConfig)
      .pipe(map((response) => response));
  }

  modifyToolConfig(toolConfigId, toolConfig) {
    return this.http
      .put(this.apiBaseUrl + 'api/private/v1/toolConfiguration/' + toolConfigId, toolConfig)
      .pipe(map((response) => response));
  }

  deleteToolConfig(toolConfigId) {
    return this.http
      .delete(this.apiBaseUrl + 'api/private/v1/toolConfiguration/' + toolConfigId)
      .pipe(
        map(() => {
          return { id: toolConfigId };
        })
      );
  }
}
